export default 'd2dApp';
